import EmailTemplateType from "@/models/EmailTemplates/EmailTemplateType";

export default class CreateEmailTemplateRequest  {
	name = '';  
	type: EmailTemplateType;
	templateId = ''; 
}